import React, { useEffect, useState } from "react";
import { Divider } from "primereact/divider";
import totalashas from "../../../Assets/totalashas.png";
import familiesregistered from "../../../Assets/familiesregistered.png";
import activeschemas from "../../../Assets/activeschemes.png";
import activeVisitPerMonth from "../../../Assets/activevisitprmonth.png";
import "./OverViewDetails.scss";
import { Dialog } from "primereact/dialog";
import ModalHeader from "../../../Components/Header/ModalHeader";
import TotalAshaTableView from "../AshaAnmSection/TotalAshaView/TotalAshaTableView";
import * as masterSelectors from "../../../Store/Dashboard/DashboardSelectors";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLanguage } from "../../ChangeLanguage/LanguageProvider";
import { months } from "../../../Shared/Constant/monthYear";
import { fetchTotalTopAsha } from "../../../Store/Dashboard/DashboardActions";
import { fetchTotalDashboardCount } from "../../../Services/DashboardService";
import GetAreaId from "../../../Shared/Utils/getAreaId";
import TotalFamilyView from "../AshaAnmSection/FamilyDetail/TotalFamilyView";
import IncentiveView from "../AshaAnmSection/Incentive Deatils/IncentiveView";

const OverViewDetails = () => {
  const { selectedLanguageId } = useLanguage();
  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth();
  const currentMonth = months[currentMonthIndex - 1];
  const { t } = useTranslation();
  const phc = sessionStorage.getItem("phcId");
  const areaType = useSelector(masterSelectors.getGlobalAreaType) || null;
  const [isAshaTableVisible, setIsAshaTableVisible] = useState(false);
  const [isFamilyTableVisible, setIsFamilyTableVisible] = useState(false);
  const [isIncentiveVisible, setIsIncentiveVisible] = useState(false);
  const [approvedCount, setApprovedCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [familyCount, setFamilyCount] = useState("");
  const [incentiveCount, setIncentiveCount] = useState({});
  const [schemeCount, setSchemeCount] = useState("");
  const [ashaCount, setAshaCount] = useState("");
  const [activeAshaCount, setActiveAshaCount] = useState("");
  const [inActiveAshaCount, setInactiveAshaCount] = useState("");
  const closeDialog = () => {
    setIsAshaTableVisible(false);
    setIsFamilyTableVisible(false);
    setIsIncentiveVisible(false);
  };

  var allDashboardCount = async (phc, areaType, selectedLanguageId) => {
    try {
      const dashboardData = await fetchTotalDashboardCount(
        GetAreaId(areaType),
        selectedLanguageId,
        phc
      );
      setAshaCount(dashboardData.ashaCount);
      setFamilyCount(dashboardData.familyCount);
      setIncentiveCount(dashboardData.incentiveData);
      // setSchemeCount(dashboardData.schemeCount); // Using schemeCount
      setActiveAshaCount(dashboardData.activeAsha);
      setInactiveAshaCount(dashboardData.inactiveAsha);
      setApprovedCount(dashboardData.approvedVisitCount || 0);
      setPendingCount(dashboardData.pendingVisitCount || 0);
    } catch (error) {
      console.error("Error fetching all data:", error);
    }
  };
  useEffect(() => {
    if (areaType && selectedLanguageId) {
      const fetchData = async () => {
        try {
          await fetchTotalTopAsha(GetAreaId(areaType), selectedLanguageId);
          await allDashboardCount(
            phc,
            areaType,
            selectedLanguageId,
            currentMonth,
            currentYear
          );
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    }
  }, [phc, areaType, selectedLanguageId, currentMonth, currentYear]);
  const handleTotalAshaClick = () => {
    setIsAshaTableVisible(true);
  };

  const handleFamilyClick = () => {
    setIsFamilyTableVisible(true);
  };
  const handleIncentiveClick = () => {
    setIsIncentiveVisible(true);
  };

  const styleMar = "0 30px 0 0";
  return (
    <>
      <div className="flex bg-white border-round-md ml-1 pr-2 pl-2 flex-wrap">
        <div className="flex-grow-1 flex justify-content-center p-2">
          <div className="align-items-center justify-content-evenly flex">
            <div className="mr-4" data-testid="total-ashas-image">
              <img src={totalashas} alt="Total Ashas" />
            </div>
            <div
              className="top-cards-asha"
              style={{ width: "125px" }}
              onClick={handleTotalAshaClick}
              data-testid="total-ashas-section"
            >
              <div className="text-sm font-bold text-dark">{t("ttlAsha")}</div>
              {ashaCount > 0 ? (
                <div className="text-xl font-semibold text-600">
                  {activeAshaCount + inActiveAshaCount}
                </div>
              ) : (
                <div className="text-xl font-semibold text-600">-</div>
              )}
            </div>
          </div>
        </div>
        <Divider layout="vertical" className="hidden md:block" style={{ margin: styleMar }} />
        <div className="flex-grow-1 flex justify-content-center p-2" style={{ opacity: "1" }}>
          <div className="align-items-center justify-content-evenly p-2 flex">
            <div className="mr-4" data-testid="families-registered-image">
              <img src={familiesregistered} alt="Families Registered" />
            </div>
            <div style={{ width: "125px" }} onClick={handleFamilyClick}>
              <div className="text-sm font-bold text-dark">{t("tFamilyR")}</div>
              {familyCount > 0 ? (
                <div className="text-xl font-semibold text-600">
                  {familyCount}
                </div>
              ) : (
                <div className="text-xl font-semibold text-600">-</div>
              )}
            </div>
          </div>
        </div>
        <Divider layout="vertical" className="hidden md:block" style={{ margin: styleMar }} />
        <div className="flex-grow-1 flex justify-content-center p-2" style={{ opacity: "1" }}>
          <div className="flex flex-column align-items-center justify-content-evenly p-2 w-full">
            <div className="text-sm font-bold text-dark mb-3">
              {t("tNIncentive")}
            </div>
            <div className="flex align-items-center justify-content-start w-full">
              <div className="mr-4" data-testid="asha-visit-image">
                <img src={activeVisitPerMonth} alt="Visit Stats Icon" />
              </div>
              <div className="flex align-items-center justify-content-start gap-5 p-2 flex-grow-1" data-testid="asha-visit-stats">
                <div
                  className="flex flex-column text-center cursor-pointer"
                  onClick={handleIncentiveClick}
                >
                  <span className="text-xl font-semibold text-600">{incentiveCount?.approved_amount || 0}</span>
                  <label className="text-sm font-bold text-dark">Approved</label>
                </div>
                <div
                  className="flex flex-column text-center cursor-pointer"
                  onClick={handleIncentiveClick}
                >
                  <span className="text-xl font-semibold text-600">{incentiveCount?.inprogress_amount || 0}</span>
                  <label className="text-sm font-bold text-dark">Inprocess</label>
                </div>
                <div
                  className="flex flex-column text-center cursor-pointer"
                  onClick={handleIncentiveClick}
                >
                  <span className="text-xl font-semibold text-600">{incentiveCount?.asha_count}</span>
                  <label className="text-sm font-bold text-dark">Asha Count</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Divider layout="vertical" className="hidden md:block" style={{ margin: styleMar }} />
        <div className="flex-grow-1 flex justify-content-center p-2" style={{ opacity: "0.6" }}>
          <div className="align-items-center justify-content-evenly p-2 flex">
            <div className="mr-4" data-testid="active-schemes-image">
              <img src={activeschemas} alt="Active Schemes" />
            </div>
            <div style={{ width: "130px" }}>
              <div className="text-sm font-bold text-dark">
                {t("tASchemes")}
              </div>
              {schemeCount > 0 ? (
                <div className="text-xl font-semibold text-600">
                  {schemeCount}
                </div>
              ) : (
                <div className="text-xl font-semibold text-600">-</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Dialog
        className="cockpit-dialog"
        visible={isAshaTableVisible}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => setIsAshaTableVisible(false)}
        closeOnEscape={false}
        header={
          <ModalHeader onClose={closeDialog} backText={t("backtodashboard")} />
        }
      >
        <TotalAshaTableView activeAshaCount={activeAshaCount} inActiveAshaCount={inActiveAshaCount} />
      </Dialog>

      {/* Families Modal */}
      <Dialog
        className="cockpit-dialog"
        visible={isFamilyTableVisible}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => setIsFamilyTableVisible(false)}
        closeOnEscape={false}
        header={
          <ModalHeader onClose={closeDialog} backText={t("backtodashboard")} />
        }
      >
        <TotalFamilyView areaType={areaType} selectedLanguageId={selectedLanguageId} />
      </Dialog>
      <Dialog
        className="cockpit-dialog"
        visible={isIncentiveVisible}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={() => setIsIncentiveVisible(false)}
        closeOnEscape={false}
        header={
          <ModalHeader onClose={closeDialog} backText={t("backtodashboard")} />
        }
      >
        <IncentiveView areaType={areaType} selectedLanguageId={selectedLanguageId} />
      </Dialog>
    </>
  );
};

export default OverViewDetails;
